/* import __COLOCATED_TEMPLATE__ from './group-deactivation-confirmation-modal.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';
import type { ScimGroup } from './types';

interface Args {
  isVisible: boolean;
  selectedGroup: ScimGroup | null;
  currentRoleName: string;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
  Blocks: {};
}

const ScimGroupDeactivationConfirmationModal = templateOnlyComponent<Signature>();

export default ScimGroupDeactivationConfirmationModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::GroupDeactivationConfirmationModal': typeof ScimGroupDeactivationConfirmationModal;
    'new-settings/workspace/teammates/scim/group-deactivation-confirmation-modal': typeof ScimGroupDeactivationConfirmationModal;
  }
}
